import React from "react";
import { Box } from "app/components/common";
import { heightPercentageToDP } from "react-native-responsive-screen";

const MyBottomSheet = ({
  children,
  snapPoints,
  isBottomSheetOpen,
  containerStyle,
  ...props
}) => {
  return (
    <Box
      style={[
        containerStyle,
        {
          position: "fixed",
          bottom: 0,
          left: 0,
          minHeight: 50,
          transition: "all 0.2s ease",
        },
        isBottomSheetOpen && { height: heightPercentageToDP(92) },
      ]}
      backgroundColor="neutral.white"
      paddingTop="m"
    >
      {children}
    </Box>
  );
};

export default MyBottomSheet;
